import { Actions, createEffect, ofType } from "@ngrx/effects";
import { throwError, from, Observable, EMPTY, Subject, map, switchMap, catchError, tap, mergeMap, take } from "rxjs";
import { WrapperService } from "../_services/wrapper-service.service";
import {
  loadRates,
  loadRatesHappy,
  ratesLoaded,
  ratesLoadedFailed,
} from "../_actions/rates.actions";
import * as ActionConfigurationManager from "../_actions/config.actions";
import { Router } from "@angular/router";
import {
  ratesError,
  success,
  invalidState,
  productExist,
  lamboNeverEligible,
  notWithinSixtyDays,
  hasExistingClaims,
  mileageOrAgeExceeded,
  ncesiMileageOrAgeExceeded
} from "../_actions/modal-component.actions";
import { Store } from "@ngrx/store";
import { hideInlineLoader } from "../_actions/inline-loader.actions";
import { Vehicle } from "../_models/vehicle";
import {
  loadVehicle,
  loadVehicleImage,
  updateOdometer,
} from "../_actions/vehicle.actions";
import { Injectable } from "@angular/core";
import brandInfo from "src/environments/brand.json";
import { MDBModalService, MDBModalRef } from '../mdb-compat';
import { ProductHomeModalComponent } from "src/app/product-home/product-home-modal/product-home-modal.component";
import { clearCart } from "../_actions/cart.actions";
import {
  shouldDeferHppGenesisServiceDriveProductOutcome,
  resolveHyundaiServiceDriveAfterLoop,
  applyHyundaiServiceDriveOutcome,
} from "./hpp-genesis-rates.helpers";

@Injectable()
export class RateEffects {
  private modalRef: MDBModalRef;
  private modalClosed$ = new Subject<boolean>();

  public saveRates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadRates),
      mergeMap((action: any) => {
        const oldVehicle = JSON.parse(sessionStorage.getItem("oldVehicle"));
        const currentVehicle = JSON.parse(sessionStorage.getItem("vehicle"));
        const cart = JSON.parse(sessionStorage.getItem('cart'));

        if (
          oldVehicle &&
          currentVehicle &&
          cart &&
          oldVehicle.vin !== currentVehicle.vin
        ) {
          this.modalRef = this.modalService.show(ProductHomeModalComponent);
          this.modalRef.content.modalRefCart = this.modalRef;
          this.modalRef.content.callbackFunction = () => {
            this.store.dispatch(clearCart());
            this.modalClosed$.next(true);
          };
          this.modalRef.content.cancelCallback = () => {
            this.store.dispatch(hideInlineLoader());
            this.modalClosed$.next(false);
          };
          return this.modalClosed$.pipe(
            take(1),
            mergeMap((result) => {
              if (result) {
                return this.ratesService
                  .get_rates(action)
                  .pipe(map((rates) => ({ rates, action })));
              } else {
                return EMPTY;
              }
            })
          );
        }

        return this.ratesService
          .get_rates(action)
          .pipe(map((rates) => ({ rates, action })));
      }),
      map(({ rates, action }) => {
        console.log("Call 1", rates);

        let _vehicle: Vehicle = JSON.parse(sessionStorage.getItem("vehicle"));

        for (let i = 0; i < rates.data.productDetailsList.length; i++) {
          if (rates.data.productDetailsList[i].statusCode === 100) {
            let request: Vehicle = {
              isElectric: action.isElectric,
              make: rates.data.vehicleMake,
              makeExternalId: "",
              makeSfId: "",
              model: rates.data.vehicleModel,
              modelExternalId: "",
              modelSfId: "",
              modelNumber: "",
              purchaseDate: "",
              inserviceDate: rates.data?.inServiceDate
                ? rates.data.inServiceDate
                : null,
              mfrWarrantyDate: "",
              deliveryDate: "",
              exteriorColor: "",
              referenceNumber1: "",
              referenceNumber2: "",
              referenceNumber3: "",
              referenceNumber4: "",
              registeredState: action.customerState,
              mileage: action.odometer,
              trim: rates.data.vehicleTrim,
              vehicleCondition: "",
              vehicleExternalId: "",
              vehicleSfId: "",
              vehicleType: "",
              trimExternalId: "",
              trimSfId: "",
              vin: action.vin,
              year: rates.data.vehicleYear,
            };

            if (_vehicle) {
              request.isElectric = _vehicle.isElectric;
            }

            if (brandInfo.brand === 'HPP' || brandInfo.brand === 'Genesis' || brandInfo.brand === 'Kia') {
              if (action.product === 'PPM' && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                this.store.dispatch(loadVehicle(request));
                this.store.dispatch(ratesLoaded(rates));
                this.store.dispatch(loadVehicleImage(request));
                this.store.dispatch(hideInlineLoader());
                return success();
              } else if (action.product === 'VSC' && rates.data.productDetailsList[i].productCategory === 'Vehicle Service') {
                this.store.dispatch(loadVehicle(request));
                this.store.dispatch(ratesLoaded(rates));
                this.store.dispatch(loadVehicleImage(request));
                this.store.dispatch(hideInlineLoader());
                return success();
              } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                this.store.dispatch(loadVehicle(request));
                this.store.dispatch(ratesLoaded(rates));
                this.store.dispatch(loadVehicleImage(request));
                this.store.dispatch(hideInlineLoader());
                return success();
              } else if (rates.data.productDetailsList.length === 1) {
                this.store.dispatch(loadVehicle(request));
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(loadVehicleImage(request));
                this.store.dispatch(hideInlineLoader());
                return ratesError();
              }
            } else {
              this.store.dispatch(loadVehicle(request));
              this.store.dispatch(ratesLoaded(rates));
              this.store.dispatch(loadVehicleImage(request));
              this.store.dispatch(hideInlineLoader());
              return success();
            }
          } else if (rates.data.productDetailsList[i].statusCode === 101) {
            this.store.dispatch(ratesLoadedFailed(rates));
            this.store.dispatch(hideInlineLoader());
            return invalidState();
          } else if (rates.data.productDetailsList[i].statusCode === 102) {
            console.log("action.product", action.product);
            console.log("rates.data.productDetailsList[i].productName", rates.data.productDetailsList[i].productName);
            console.log("brandInfo.isMultiProduct", brandInfo.isMultiProduct);
            if (brandInfo.isMultiProduct) {
              if (brandInfo.brand === "NCESI") {
                if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return productExist();
                } else if (action.product !== "PPM" && rates.data.productDetailsList[i].productCode === "NASP") {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return productExist();
                }
              } else if (brandInfo.brand === "Porsche" && rates.data.productDetailsList.length > 1) {
                if (i === rates.data.productDetailsList.length - 1) {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return productExist();
                }
              } else if (brandInfo.brand === "HPP" || brandInfo.brand === "Genesis" || brandInfo.brand === "Kia") {
                if (shouldDeferHppGenesisServiceDriveProductOutcome()) {
                  continue;
                }

                let request: Vehicle = {
                  isElectric: action.isElectric,
                  make: rates.data.vehicleMake,
                  makeExternalId: "",
                  makeSfId: "",
                  model: rates.data.vehicleModel,
                  modelExternalId: "",
                  modelSfId: "",
                  modelNumber: "",
                  purchaseDate: "",
                  inserviceDate: rates.data?.inServiceDate
                    ? rates.data.inServiceDate
                    : null,
                  mfrWarrantyDate: "",
                  deliveryDate: "",
                  exteriorColor: "",
                  referenceNumber1: "",
                  referenceNumber2: "",
                  referenceNumber3: "",
                  referenceNumber4: "",
                  registeredState: action.customerState,
                  mileage: action.odometer,
                  trim: rates.data.vehicleTrim,
                  vehicleCondition: "",
                  vehicleExternalId: "",
                  vehicleSfId: "",
                  vehicleType: "",
                  trimExternalId: "",
                  trimSfId: "",
                  vin: action.vin,
                  year: rates.data.vehicleYear,
                };

                if (_vehicle) {
                  request.isElectric = _vehicle.isElectric;
                }

                if (action.product === "PPM" && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                  this.store.dispatch(loadVehicle(request));
                  this.store.dispatch(ratesLoaded(rates));
                  this.store.dispatch(loadVehicleImage(request));
                  this.store.dispatch(hideInlineLoader());
                  return productExist();
                } else if (action.product === "VSC" && rates.data.productDetailsList[i].productCategory === 'Vehicle Service') {
                  this.store.dispatch(loadVehicle(request));
                  this.store.dispatch(ratesLoaded(rates));
                  this.store.dispatch(loadVehicleImage(request));
                  this.store.dispatch(hideInlineLoader());
                  return productExist();
                } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                  this.store.dispatch(loadVehicle(request));
                  this.store.dispatch(ratesLoaded(rates));
                  this.store.dispatch(loadVehicleImage(request));
                  this.store.dispatch(hideInlineLoader());
                  return productExist();
                }

              } else {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return productExist();
              }
            } else {
              this.store.dispatch(ratesLoadedFailed(rates));
              this.store.dispatch(hideInlineLoader());
              return productExist();
            }
          } else if (rates.data.productDetailsList[i].statusCode === 103) {
            if (brandInfo.isMultiProduct) {
              if (brandInfo.brand === "NCESI") {
                if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return lamboNeverEligible();
                } else if (action.product !== "PPM" && rates.data.productDetailsList[i].productCode === "NASP") {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return lamboNeverEligible();
                }
              } else if (brandInfo.brand === "Porsche" && rates.data.productDetailsList.length > 1) {
                if (i === rates.data.productDetailsList.length - 1) {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return lamboNeverEligible();
                }
              } else {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return lamboNeverEligible();
              }
            } else {
              this.store.dispatch(ratesLoadedFailed(rates));
              this.store.dispatch(hideInlineLoader());
              return lamboNeverEligible();
            }
          } else if (rates.data.productDetailsList[i].statusCode === 104) {
            this.store.dispatch(ratesLoadedFailed(rates));
            this.store.dispatch(hideInlineLoader());
            return notWithinSixtyDays();
          } else if (rates.data.productDetailsList[i].statusCode === 105) {
            if (brandInfo.isMultiProduct) {
              if (brandInfo.brand === "HPP" || brandInfo.brand === "Genesis" || brandInfo.brand === "Kia") {
                if (shouldDeferHppGenesisServiceDriveProductOutcome()) {
                  continue;
                }

                if (action.product === "PPM" && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                  this.store.dispatch(ratesLoadedFailed(rates))
                  this.store.dispatch(hideInlineLoader())
                  return  (mileageOrAgeExceeded())
                } else if (action.product === 'VSC' && rates.data.productDetailsList[i].productCategory === 'Vehicle Service') {
                  this.store.dispatch(ratesLoadedFailed(rates))
                  this.store.dispatch(hideInlineLoader())
                  return (mileageOrAgeExceeded())
                } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return (mileageOrAgeExceeded());
                }
              } else if (brandInfo.brand === "NCESI") {
                if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return (mileageOrAgeExceeded());
                } else if (action.product !== "PPM" && rates.data.productDetailsList[i].productCode === "NASP") {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return (mileageOrAgeExceeded());
                } else if (rates.data.productDetailsList.length === 1) {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return (mileageOrAgeExceeded());
                }
              } else {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return (mileageOrAgeExceeded());
              }
            } else {
              this.store.dispatch(ratesLoadedFailed(rates));
              this.store.dispatch(hideInlineLoader());
              return (mileageOrAgeExceeded());
            }
          } else if (rates.data.productDetailsList[i].statusCode === 106) {
            if (brandInfo.brand === "HPP" || brandInfo.brand === "Genesis" || brandInfo.brand === "Kia") {
              if (shouldDeferHppGenesisServiceDriveProductOutcome()) {
                continue;
              }

              if (action.product === "PPM" && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return hasExistingClaims();
              } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return hasExistingClaims();
              } else {
                // Fallback when conditions don't match
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return hasExistingClaims();
              }
            } else {
              // Fallback for other brands
              this.store.dispatch(ratesLoadedFailed(rates));
              this.store.dispatch(hideInlineLoader());
              return hasExistingClaims();
            }
          } else if (rates.data.productDetailsList[i].statusCode === 107) {
            if (brandInfo.brand === "NCESI") {
              if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return (ncesiMileageOrAgeExceeded());
              } else if (action.product !== "PPM" && rates.data.productDetailsList[i].productCode === "NASP") {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return (ncesiMileageOrAgeExceeded());
              } else if (rates.data.productDetailsList.length === 1) {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return (ncesiMileageOrAgeExceeded());
              }
            } else {
              this.store.dispatch(ratesLoadedFailed(rates));
              this.store.dispatch(hideInlineLoader());
              return (ncesiMileageOrAgeExceeded());
            }
          }
        }
        const mixedRatesOutcome = this.finishHyundaiServiceDriveMixedProducts(
          rates,
          action,
          _vehicle,
          Number(action.odometer)
        );
        if (mixedRatesOutcome) {
          return mixedRatesOutcome;
        }

        // Fallback if no status code matched
        this.store.dispatch(ratesLoadedFailed(rates));
        this.store.dispatch(hideInlineLoader());
        return invalidState();
      }),
      catchError((error) => {
        this.store.dispatch(ratesError());
        this.store.dispatch(hideInlineLoader());
        return throwError(error);
      })
    )
  );

  public saveRatesHappy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadRatesHappy),
      mergeMap((action) => {
        const oldVehicle = JSON.parse(sessionStorage.getItem("oldVehicle"));
        const currentVehicle = JSON.parse(sessionStorage.getItem("vehicle"));
        const cart = JSON.parse(sessionStorage.getItem('cart'));


        if (
          oldVehicle &&
          currentVehicle &&
          cart &&
          oldVehicle.vin !== currentVehicle.vin
        ) {
          this.modalRef = this.modalService.show(ProductHomeModalComponent);
          this.modalRef.content.modalRefCart = this.modalRef;
          this.modalRef.content.callbackFunction = () => {
            this.store.dispatch(clearCart());
            this.modalClosed$.next(true);
          };
          this.modalRef.content.cancelCallback = () => {
            this.store.dispatch(hideInlineLoader());
            this.modalClosed$.next(false);
          };
          return this.modalClosed$.pipe(
            take(1),
            mergeMap((result) => {
              if (result) {
                return this.ratesService.get_rates(action).pipe(
                  map((rates) => {
                    console.log("************ 1");
                    console.log("1. loaded rates from api R:", rates, action);
                    console.log(
                      `2. Found ${rates.data.productDetailsList.length} products`
                    );

                    let odometer =
                      action.odometer &&
                        typeof action.odometer === "string" &&
                        action.odometer.includes(",")
                        ? action.odometer.replace(",", "")
                        : action.odometer;

                    let _vehicle: Vehicle = JSON.parse(
                      sessionStorage.getItem("vehicle")
                    );
                    for (
                      let i = 0;
                      i < rates.data.productDetailsList.length;
                      i++
                    ) {
                      if (rates.data.productDetailsList[i].statusCode === 100) {
                        // Set the registration State and mileage.
                        if (_vehicle) {
                          console.log(
                            "3. Update state and mileage on vehicle in store:",
                            action
                          );
                          _vehicle.registeredState = action.customerState;
                          _vehicle.inserviceDate = rates.data.inServiceDate
                            ? rates.data.inServiceDate
                            : null;
                          _vehicle.mileage = Number(odometer);
                          _vehicle.vehicleSfId = "";
                          _vehicle.isElectric = rates.data.productDetailsList[
                            i
                          ].productName.includes("EV")
                            ? true
                            : false;
                          console.log(
                            "EVEHICLE:",
                            rates.data.productDetailsList[
                              i
                            ].productName.includes("EV")
                              ? true
                              : false
                          );
                          _vehicle.make = rates.data.vehicleMake;
                          _vehicle.model = rates.data.vehicleModel;
                          _vehicle.trim = rates.data.vehicleTrim;
                          _vehicle.year = rates.data.vehicleYear;
                          this.store.dispatch(updateOdometer(_vehicle));
                        }
                        console.log("4. Vehicle after action", _vehicle);
                        this.store.dispatch(ratesLoaded(rates));
                        this.store.dispatch(loadVehicleImage(_vehicle));
                        console.log(
                          "5. Switch to get rates page:",
                          _vehicle,
                          action
                        );
                        console.log("************");
                        if (brandInfo.brand === 'HPP' || brandInfo.brand === 'Genesis' || brandInfo.brand === 'Kia') {
                          if (action.product === 'PPM' && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                            return success();
                          } else if (action.product === 'VSC' && rates.data.productDetailsList[i].productCategory === 'Vehicle Service') {
                            return success();
                          } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                            return success();
                          } else if (rates.data.productDetailsList.length === 1) {
                            this.store.dispatch(ratesLoadedFailed(rates));
                            this.store.dispatch(hideInlineLoader());
                            return ratesError();
                          }
                        } else {
                          return success();
                        }
                      } else if (rates.data.productDetailsList[i].statusCode === 101) {
                        this.store.dispatch(ratesLoadedFailed(rates));
                        this.store.dispatch(hideInlineLoader());
                        return invalidState();
                      } else if (rates.data.productDetailsList[i].statusCode === 102) {
                        if (brandInfo.isMultiProduct) {
                          if (brandInfo.brand === "NCESI") {
                            if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                              return productExist();
                            } else if (
                              action.product !== "PPM" &&
                              rates.data.productDetailsList[i].productCode ===
                              "NASP"
                            ) {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                              return productExist();
                            }
                          } else if (brandInfo.brand === "Porsche" && rates.data.productDetailsList.length > 1) {
                            if (i === rates.data.productDetailsList.length - 1) {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                              return productExist();
                            }
                          } else if (brandInfo.brand === "HPP" || brandInfo.brand === "Genesis" || brandInfo.brand === "Kia") {
                            if (shouldDeferHppGenesisServiceDriveProductOutcome()) {
                              continue;
                            }

                            let request: Vehicle = {
                              isElectric: null,
                              make: rates.data.vehicleMake,
                              makeExternalId: "",
                              makeSfId: "",
                              model: rates.data.vehicleModel,
                              modelExternalId: "",
                              modelSfId: "",
                              modelNumber: "",
                              purchaseDate: "",
                              inserviceDate: rates.data?.inServiceDate
                                ? rates.data.inServiceDate
                                : null,
                              mfrWarrantyDate: "",
                              deliveryDate: "",
                              exteriorColor: "",
                              referenceNumber1: "",
                              referenceNumber2: "",
                              referenceNumber3: "",
                              referenceNumber4: "",
                              registeredState: action.customerState,
                              mileage: Number(action.odometer),
                              trim: rates.data.vehicleTrim,
                              vehicleCondition: "",
                              vehicleExternalId: "",
                              vehicleSfId: "",
                              vehicleType: "",
                              trimExternalId: "",
                              trimSfId: "",
                              vin: action.vin,
                              year: rates.data.vehicleYear,
                            };

                            if (_vehicle) {
                              request.isElectric = _vehicle.isElectric;
                            }
                            if (action.product === "PPM" && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                              this.store.dispatch(loadVehicle(request));
                              this.store.dispatch(ratesLoaded(rates));
                              this.store.dispatch(loadVehicleImage(request));
                              this.store.dispatch(hideInlineLoader());
                              return productExist();
                            } else if (action.product === "VSC" && rates.data.productDetailsList[i].productCategory === 'Vehicle Service') {
                              this.store.dispatch(loadVehicle(request));
                              this.store.dispatch(ratesLoaded(rates));
                              this.store.dispatch(loadVehicleImage(request));
                              this.store.dispatch(hideInlineLoader());
                              return productExist();
                            } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                              this.store.dispatch(loadVehicle(request));
                              this.store.dispatch(ratesLoaded(rates));
                              this.store.dispatch(loadVehicleImage(request));
                              this.store.dispatch(hideInlineLoader());
                              return productExist();
                            }
                          }
                        } else {
                          this.store.dispatch(ratesLoadedFailed(rates));
                          this.store.dispatch(hideInlineLoader());
                          return productExist();
                        }
                      } else if (rates.data.productDetailsList[i].statusCode === 103) {
                        if (brandInfo.isMultiProduct) {
                          if (brandInfo.brand === "NCESI") {
                            if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                              return lamboNeverEligible();
                            } else if (action.product !== "PPM" && rates.data.productDetailsList[i].productCode === "NASP") {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                              return lamboNeverEligible();
                            }
                          } else if (brandInfo.brand === "Porsche" && rates.data.productDetailsList.length > 1) {
                            if (i === rates.data.productDetailsList.length - 1) {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                              return lamboNeverEligible();
                            }
                          } else {
                            this.store.dispatch(ratesLoadedFailed(rates));
                            this.store.dispatch(hideInlineLoader());
                            return lamboNeverEligible();
                          }
                        } else {
                          this.store.dispatch(ratesLoadedFailed(rates));
                          this.store.dispatch(hideInlineLoader());
                          return lamboNeverEligible();
                        }
                      } else if (rates.data.productDetailsList[i].statusCode === 104) {
                        this.store.dispatch(ratesLoadedFailed(rates));
                        this.store.dispatch(hideInlineLoader());
                        return notWithinSixtyDays();
                      } else if (rates.data.productDetailsList[i].statusCode === 105) {
                        if (brandInfo.isMultiProduct) {
                          if (brandInfo.brand === "HPP" || brandInfo.brand === "Genesis" || brandInfo.brand === "Kia") {
                            if (shouldDeferHppGenesisServiceDriveProductOutcome()) {
                              continue;
                            }

                            if (action.product === 'PPM' && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                              this.store.dispatch(ratesLoadedFailed(rates))
                              this.store.dispatch(hideInlineLoader())
                              return (mileageOrAgeExceeded())
                            } else if (action.product === 'VSC' && rates.data.productDetailsList[i].productCategory === 'Vehicle Service') {
                              this.store.dispatch(ratesLoadedFailed(rates))
                              this.store.dispatch(hideInlineLoader())
                              return (mileageOrAgeExceeded())
                            } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                                return (mileageOrAgeExceeded());
                            }
                          } else if (brandInfo.brand === "NCESI") {
                            if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                              return (mileageOrAgeExceeded());
                            } else if (action.product !== "PPM" && rates.data.productDetailsList[i].productCode === "NASP") {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                              return (mileageOrAgeExceeded());
                            } else if (rates.data.productDetailsList.length === 1) {
                              this.store.dispatch(ratesLoadedFailed(rates));
                              this.store.dispatch(hideInlineLoader());
                              return (mileageOrAgeExceeded());
                            }
                          } else {
                            this.store.dispatch(ratesLoadedFailed(rates));
                            this.store.dispatch(hideInlineLoader());
                            return (mileageOrAgeExceeded());
                          }
                        } else {
                          this.store.dispatch(ratesLoadedFailed(rates));
                          this.store.dispatch(hideInlineLoader());
                          return (mileageOrAgeExceeded());
                        }
                      } else if (rates.data.productDetailsList[i].statusCode === 106) {
                        if (brandInfo.brand === "HPP" || brandInfo.brand === "Genesis" || brandInfo.brand === "Kia") {
                          if (shouldDeferHppGenesisServiceDriveProductOutcome()) {
                            continue;
                          }

                          if (action.product === "PPM" && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                            this.store.dispatch(ratesLoadedFailed(rates));
                            this.store.dispatch(hideInlineLoader());
                            return hasExistingClaims();
                          } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                            this.store.dispatch(ratesLoadedFailed(rates));
                            this.store.dispatch(hideInlineLoader());
                            return hasExistingClaims();
                          } else {
                            // Fallback when conditions don't match
                            this.store.dispatch(ratesLoadedFailed(rates));
                            this.store.dispatch(hideInlineLoader());
                            return hasExistingClaims();
                          }
                        } else {
                          // Fallback for other brands
                          this.store.dispatch(ratesLoadedFailed(rates));
                          this.store.dispatch(hideInlineLoader());
                          return hasExistingClaims();
                        }
                      } else if (rates.data.productDetailsList[i].statusCode === 107) {
                        if (brandInfo.brand === "NCESI") {
                          if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                            this.store.dispatch(ratesLoadedFailed(rates));
                            this.store.dispatch(hideInlineLoader());
                            return (ncesiMileageOrAgeExceeded());
                          } else if (action.product !== "PPM" && rates.data.productDetailsList[i].productCode === "NASP") {
                            this.store.dispatch(ratesLoadedFailed(rates));
                            this.store.dispatch(hideInlineLoader());
                            return (ncesiMileageOrAgeExceeded());
                          } else if (rates.data.productDetailsList.length === 1) {
                            this.store.dispatch(ratesLoadedFailed(rates));
                            this.store.dispatch(hideInlineLoader());
                            return (ncesiMileageOrAgeExceeded());
                          }
                        } else {
                          this.store.dispatch(ratesLoadedFailed(rates));
                          this.store.dispatch(hideInlineLoader());
                          return (ncesiMileageOrAgeExceeded());
                        }
                      }
                    }
                    const happyInnerMixedOutcome =
                      this.finishHyundaiServiceDriveMixedProducts(
                        rates,
                        action,
                        _vehicle,
                        Number(odometer)
                      );
                    if (happyInnerMixedOutcome) {
                      return happyInnerMixedOutcome;
                    }

                    this.store.dispatch(hideInlineLoader()); // No products were returned
                    return invalidState();
                  })
                );
              } else {
                this.store.dispatch(hideInlineLoader());
                return EMPTY;
              }
            })
          );
        }

        return this.ratesService.get_rates(action).pipe(
          map((rates) => {
            console.log("************ 1");
            console.log("1. loaded rates from api A:", rates, action);
            console.log(
              `2. Found ${rates.data.productDetailsList.length} products`
            );
            let odometer =
              action.odometer &&
                typeof action.odometer === "string" &&
                action.odometer.includes(",")
                ? action.odometer.replace(",", "")
                : action.odometer;

            let _vehicle: Vehicle = JSON.parse(
              sessionStorage.getItem("vehicle")
            );
            for (let i = 0; i < rates.data.productDetailsList.length; i++) {
              if (rates.data.productDetailsList[i].statusCode === 100) {
                // Set the registration State and mileage.
                if (_vehicle) {
                  console.log(
                    "3. Update state and mileage on vehicle in store:",
                    action
                  );
                  _vehicle.registeredState = action.customerState;
                  _vehicle.inserviceDate = rates.data.inServiceDate
                    ? rates.data.inServiceDate
                    : null;
                  _vehicle.mileage = Number(odometer);
                  _vehicle.vehicleSfId = "";
                  _vehicle.isElectric = rates.data.productDetailsList[
                    i
                  ].productName.includes("EVEHICLE") || rates.data.productDetailsList[i].productName.includes("EV")
                    ? true
                    : false;
                  console.log(
                    "EVEHICLE:",
                    rates.data.productDetailsList[i].productName.includes(
                      "EVEHICLE"
                    ) || rates.data.productDetailsList[i].productName.includes("EV")
                      ? true
                      : false
                  );
                  _vehicle.make = rates.data.vehicleMake;
                  _vehicle.model = rates.data.vehicleModel;
                  _vehicle.trim = rates.data.vehicleTrim;
                  _vehicle.year = rates.data.vehicleYear;
                  this.store.dispatch(updateOdometer(_vehicle));
                }
                console.log("4. Vehicle after action", _vehicle);
                this.store.dispatch(ratesLoaded(rates));
                this.store.dispatch(loadVehicleImage(_vehicle));
                console.log("5. Switch to get rates page:", _vehicle, action);
                console.log("************");

                if (brandInfo.brand === 'HPP' || brandInfo.brand === 'Genesis' || brandInfo.brand === 'Kia') {
                  if (action.product === 'PPM' && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                    return success();
                  } else if (action.product === 'VSC' && rates.data.productDetailsList[i].productCategory === 'Vehicle Service') {
                    return success();
                  } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                    return success();
                  } else if (rates.data.productDetailsList.length === 1) {
                    this.store.dispatch(ratesLoadedFailed(rates));
                    this.store.dispatch(hideInlineLoader());
                    return ratesError();
                  }
                } else {
                  return success();
                }
              } else if (rates.data.productDetailsList[i].statusCode === 101) {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return invalidState();
              } else if (rates.data.productDetailsList[i].statusCode === 102) {
                if (brandInfo.isMultiProduct) {
                  if (brandInfo.brand === "NCESI") {
                    if (
                      action.product === "PPM" &&
                      rates.data.productDetailsList[i].productCode === "NPPM"
                    ) {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return productExist();
                    } else if (
                      action.product !== "PPM" &&
                      rates.data.productDetailsList[i].productCode === "NASP"
                    ) {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return productExist();
                    }
                  } else if (
                    brandInfo.brand === "Porsche" &&
                    rates.data.productDetailsList.length > 1
                  ) {
                    if (i === rates.data.productDetailsList.length - 1) {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return productExist();
                    }
                  } else if (brandInfo.brand === "HPP" || brandInfo.brand === "Genesis" || brandInfo.brand === "Kia") {
                    if (shouldDeferHppGenesisServiceDriveProductOutcome()) {
                      continue;
                    }

                    let request: Vehicle = {
                      isElectric: null,
                      make: rates.data.vehicleMake,
                      makeExternalId: "",
                      makeSfId: "",
                      model: rates.data.vehicleModel,
                      modelExternalId: "",
                      modelSfId: "",
                      modelNumber: "",
                      purchaseDate: "",
                      inserviceDate: rates.data?.inServiceDate
                        ? rates.data.inServiceDate
                        : null,
                      mfrWarrantyDate: "",
                      deliveryDate: "",
                      exteriorColor: "",
                      referenceNumber1: "",
                      referenceNumber2: "",
                      referenceNumber3: "",
                      referenceNumber4: "",
                      registeredState: action.customerState,
                      mileage: Number(action.odometer),
                      trim: rates.data.vehicleTrim,
                      vehicleCondition: "",
                      vehicleExternalId: "",
                      vehicleSfId: "",
                      vehicleType: "",
                      trimExternalId: "",
                      trimSfId: "",
                      vin: action.vin,
                      year: rates.data.vehicleYear,
                    };

                    if (_vehicle) {
                      request.isElectric = _vehicle.isElectric;
                    }
                    if (action.product === "PPM" && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                      this.store.dispatch(loadVehicle(request));
                      this.store.dispatch(ratesLoaded(rates));
                      this.store.dispatch(loadVehicleImage(request));
                      this.store.dispatch(hideInlineLoader());
                      return productExist();
                    } else if (action.product === "VSC" && rates.data.productDetailsList[i].productCategory === 'Vehicle Service') {
                      this.store.dispatch(loadVehicle(request));
                      this.store.dispatch(ratesLoaded(rates));
                      this.store.dispatch(loadVehicleImage(request));
                      this.store.dispatch(hideInlineLoader());
                      return productExist();
                    } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                      this.store.dispatch(loadVehicle(request));
                      this.store.dispatch(ratesLoaded(rates));
                      this.store.dispatch(loadVehicleImage(request));
                      this.store.dispatch(hideInlineLoader());
                      return productExist();
                    }

                  } else {
                    this.store.dispatch(ratesLoadedFailed(rates));
                    this.store.dispatch(hideInlineLoader());
                    return productExist();
                  }
                } else {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return productExist();
                }
              } else if (rates.data.productDetailsList[i].statusCode === 103) {
                if (brandInfo.isMultiProduct) {
                  if (brandInfo.brand === "NCESI") {
                    if (
                      action.product === "PPM" &&
                      rates.data.productDetailsList[i].productCode === "NPPM"
                    ) {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return lamboNeverEligible();
                    } else if (
                      action.product !== "PPM" &&
                      rates.data.productDetailsList[i].productCode === "NASP"
                    ) {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return lamboNeverEligible();
                    }
                  } else if (
                    brandInfo.brand === "Porsche" &&
                    rates.data.productDetailsList.length > 1
                  ) {
                    if (i === rates.data.productDetailsList.length - 1) {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return lamboNeverEligible();
                    }
                  } else {
                    this.store.dispatch(ratesLoadedFailed(rates));
                    this.store.dispatch(hideInlineLoader());
                    return lamboNeverEligible();
                  }
                } else {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return lamboNeverEligible();
                }
              } else if (rates.data.productDetailsList[i].statusCode === 104) {
                this.store.dispatch(ratesLoadedFailed(rates));
                this.store.dispatch(hideInlineLoader());
                return notWithinSixtyDays();
              } else if (rates.data.productDetailsList[i].statusCode === 105) {
                if (brandInfo.isMultiProduct) {
                  if (brandInfo.brand === "HPP" || brandInfo.brand === "Genesis" || brandInfo.brand === "Kia") {
                    if (shouldDeferHppGenesisServiceDriveProductOutcome()) {
                      continue;
                    }

                    if (action.product === 'PPM' && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                      this.store.dispatch(ratesLoadedFailed(rates))
                      this.store.dispatch(hideInlineLoader())
                      return (mileageOrAgeExceeded())
                    } else if (action.product === 'VSC' && rates.data.productDetailsList[i].productCategory === 'Vehicle Service') {
                      this.store.dispatch(ratesLoadedFailed(rates))
                      this.store.dispatch(hideInlineLoader())
                      return (mileageOrAgeExceeded())
                    } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return (mileageOrAgeExceeded());
                    }
                  } else if (brandInfo.brand === "NCESI") {
                    if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return (mileageOrAgeExceeded());
                    } else if (action.product !== "PPM" && rates.data.productDetailsList[i].productCode === "NASP") {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return (mileageOrAgeExceeded());
                    } else if (rates.data.productDetailsList.length === 1) {
                      this.store.dispatch(ratesLoadedFailed(rates));
                      this.store.dispatch(hideInlineLoader());
                      return (mileageOrAgeExceeded());
                    }
                  } else {
                    this.store.dispatch(ratesLoadedFailed(rates));
                    this.store.dispatch(hideInlineLoader());
                    return (mileageOrAgeExceeded());
                  }
                } else {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return (mileageOrAgeExceeded());
                }
              } else if (rates.data.productDetailsList[i].statusCode === 106) {
                if (brandInfo.brand === "HPP" || brandInfo.brand === "Genesis" || brandInfo.brand === "Kia") {
                  if (shouldDeferHppGenesisServiceDriveProductOutcome()) {
                    continue;
                  }

                  if (action.product === "PPM" && rates.data.productDetailsList[i].productCategory === 'Prepaid Maintenance') {
                    this.store.dispatch(ratesLoadedFailed(rates));
                    this.store.dispatch(hideInlineLoader());
                    return hasExistingClaims();
                  } else if (sessionStorage.getItem("appFlowState").includes("serviceDrive")) {
                    this.store.dispatch(ratesLoadedFailed(rates));
                    this.store.dispatch(hideInlineLoader());
                    return hasExistingClaims();
                  }
                }
              } else if (rates.data.productDetailsList[i].statusCode === 107) {
                if (brandInfo.brand === "NCESI") {
                  if (action.product === "PPM" && rates.data.productDetailsList[i].productCode === "NPPM") {
                    this.store.dispatch(ratesLoadedFailed(rates));
                    this.store.dispatch(hideInlineLoader());
                    return (ncesiMileageOrAgeExceeded());
                  } else if (action.product !== "PPM" && rates.data.productDetailsList[i].productCode === "NASP") {
                    this.store.dispatch(ratesLoadedFailed(rates));
                    this.store.dispatch(hideInlineLoader());
                    return (ncesiMileageOrAgeExceeded());
                  } else if (rates.data.productDetailsList.length === 1) {
                    this.store.dispatch(ratesLoadedFailed(rates));
                    this.store.dispatch(hideInlineLoader());
                    return (ncesiMileageOrAgeExceeded());
                  }
                } else {
                  this.store.dispatch(ratesLoadedFailed(rates));
                  this.store.dispatch(hideInlineLoader());
                  return (ncesiMileageOrAgeExceeded());
                }
              }
            }
            const happyOuterMixedOutcome =
              this.finishHyundaiServiceDriveMixedProducts(
                rates,
                action,
                _vehicle,
                Number(odometer)
              );
            if (happyOuterMixedOutcome) {
              return happyOuterMixedOutcome;
            }

            this.store.dispatch(hideInlineLoader()); // No products were returned
            return invalidState();
          })
        );
      }),
      catchError((error) => {
        this.store.dispatch(ratesError());
        this.store.dispatch(hideInlineLoader());
        return throwError(error);
      })
    )
  );

  constructor(
    private actions$: Actions,
    private ratesService: WrapperService,
    private router: Router,
    private store: Store<{}>,
    private modalService: MDBModalService
  ) { }

  private finishHyundaiServiceDriveMixedProducts(
    rates: any,
    action: any,
    vehicle: Vehicle | null,
    odometer?: number
  ) {
    const outcome = resolveHyundaiServiceDriveAfterLoop(rates);
    return applyHyundaiServiceDriveOutcome(
      outcome,
      rates,
      action,
      vehicle,
      this.store.dispatch.bind(this.store),
      odometer
    );
  }
}
